import { DataGrid } from 'devextreme-react';
import { t } from 'i18next';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import { roleService } from '@/projects/admin/services/role-service';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const RoleList = () => {
    const dataGridRef = useRef<DataGrid>(null);
    const [mainStore] = useState(() => createCustomStore({
        key: ['id'],
        load: roleService.roleList,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
    }));
    const navigate = useNavigate();

    const goToEdit = (id: string) => {
        navigate(`/admin/role-definition/${id}`, { state: { id: id } })
    }

    return (
        <>
            <DataGridWrapper
                props={{ id: 'role-list', ref: dataGridRef, wordWrapEnabled: true }}
                permissonCode='Admin.Role.Role'
                datasource={mainStore}
                editingConfig={{ allowUpdating: true, confirmDeleteMessage: RemoveMessage(t('role')) }}
                pagerVisible={true}
                headerFilterVisible={true}
                filterVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath='/admin/role-definition'
                columns={[
                    {
                        dataField: 'name',
                        caption: t('role_name'),
                        allowSearch: true,
                    },
                    {
                        dataField: 'description',
                        caption: t('role_description'),
                        allowSearch: true,
                    },
                    {
                        dataField: 'applicationName',
                        caption: t('application'),
                        allowSearch: true,
                    },
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: (e: any) => goToEdit(e.row?.data.id),
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
        </>
    )
}
export default RoleList